/**
 * 模块：系统事件报警
 * 作者：haikuo.zhang
 * 时间：2021-09-14
 */

import Vue from 'vue';

export default {
    list: [],
    total: 0,
    imgsys: [],
    copyRegions: [],
    colsFilterChecked: ['instanceIdName', 'runStatus', 'eventType', 'eventStatus', 'eventReleaseTime', 'scheduleExecutionTime', 'eventSuccessTime', 'operation'],
    eventColsAll: [{
        name: Vue.$trans(`实例ID`) + "/" + Vue.$trans(`实例名称`),
        id: 'instanceIdName',
        disabled: true
    }, {
        name: Vue.$trans(`状态`),
        id: 'runStatus',
        disabled: false
    }, {
        name: Vue.$trans(`事件类型`),
        id: 'eventType',
        disabled: false
    }, {
        name: Vue.$trans(`事件状态`),
        id: 'eventStatus',
        disabled: false
    }, {
        name: Vue.$trans(`事件发布时间`),
        id: 'eventReleaseTime',
        disabled: false
    }, {
        name: Vue.$trans(`计划执行时间`),
        id: 'scheduleExecutionTime',
        disabled: false
    }, {
        name: Vue.$trans(`事件完成时间`),
        id: 'eventSuccessTime',
        disabled: false
    }, {
        name: Vue.$trans(`操作`),
        id: 'operation',
        disabled: true
    }],
    //默认不展示的列
    defaultOmit: [],
    get eventCols() {
        return _.omitBy(this.eventColsAll, item => {
            return item.id == 'group'
        });
    },
    set listChecked(value) {
        return value;
    },
    get listChecked() {
        let me = this,
            arr = [];
        let omit;
        try {
            omit = JSON.parse(localStorage.systemEventOmitList) || this.defaultOmit;
        } catch (e) {
            omit = this.defaultOmit;
        }
        _.forEach(this.eventColsAll, item => {
            if (_.indexOf(omit, item.id) == -1) {
                arr.push(item.id);
            }
        });
        return arr;
    },
};
